<template><div><h1>VUX V2.7.9 released</h1>
<h2><a href="/en/components/clocker.html">Clocker</a></h2>
<ul><li>[fix] fix bug when initial value is empty string #2449</li>
</ul>
<h2><a href="/en/components/panel.html">Panel</a></h2>
<ul><li>[fix] hide footer when footer.title is empty #2476</li>
</ul>
<h2><a href="/en/components/picker.html">Picker</a></h2>
<ul><li>[fix] fix typo item_class => itemClass #2457</li>
</ul>
<h2><a href="/en/components/rater.html">Rater</a></h2>
<ul><li>[feature] prop:min add min value #2439</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul><li>[enhance] support china union 166 prefix phone number</li>
</ul>
<h2><a href="/en/components/bus.html">Bus</a></h2>
<ul><li>[fix] add bus to this.$vux</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.7.9 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.7.9-147.vue?ac7f6876